export default "__VITE_ASSET__378a11fb__"